import React, { useState, useEffect } from "react";
import "../css/Modal.css";
import "../css/Onboarding.css";
import "../css/Icons.css";
import Modal from "react-modal";
import OnboardingStep1 from "../components/OnboardingStep1";
import OnboardingStep2 from "../components/OnboardingStep2";
import OnboardingStep3 from "../components/OnboardingStep3";
import OnboardingStep4 from "../components/OnboardingStep4";
import OnboardingStep5 from "../components/OnboardingStep5";
import OnboardingStep6 from "../components/OnboardingStep6";
import OnboardingStep7 from "../components/OnboardingStep7";
import OnboardingStep8 from "../components/OnboardingStep8";

const OnBoarding = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [activeStep, setActiveStep] = useState(1);
  const [activeItems, setActiveItems] = useState(
    Array.from({ length: 8 }, () => [])
  );

  const [preOpDate, setPreOpDate] = useState(() => new Date(Date.now() + 86400000));
  const [postOpDate, setPostOpDate] = useState(new Date() - 86400000);

  const closeModal = () => setIsOpen(false);
  const handleDateChange = (setter) => (date) => setter(date);
  const handleStepChange = (direction) => () =>
    setActiveStep((prevStep) => prevStep + direction);

  const toggleSubMenu = (step, item) => {
    setActiveItems((prevItems) => {
      const currentItems = prevItems[step - 1];
      return prevItems.map((items, index) =>
        index === step - 1
          ? currentItems.includes(item)
            ? currentItems.filter((activeItem) => activeItem !== item)
            : [...currentItems, item]
          : items
      );
    });
  };

  useEffect(() => {
    [
      "activity_level",
      "age",
      "gender",
      "is_preventive",
      "motivation",
      "onset_of_pain",
      "pain_level",
      "patient_name",
      "personal_goal",
      "surgery_date",
      "day_zero",
      "which_knee",
    ].forEach((key) => localStorage.removeItem(key));
  }, []);

  const renderStep = (StepComponent, stepIndex) => (
    <StepComponent
      activeItems={activeItems[stepIndex]}
      toggleSubMenu={(item) => toggleSubMenu(stepIndex + 1, item)}
      handleNext={handleStepChange(1)}
      {...(stepIndex === 0 && {
        preOpDate,
        postOpDate,
        handlePreOpDateChange: handleDateChange(setPreOpDate),
        handlePostOpDateChange: handleDateChange(setPostOpDate),
      })}
    />
  );

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        className={`onboarding-modal presignup-modal step-${activeStep}`}
        style={{
          content: {
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            padding: "20px",
            border: "0",
            borderRadius: "10px",
            maxHeight: "650px",
            width: "100%",
            maxWidth: "490px",
            textAlign: "center",
            boxShadow: "9px 10px 29.4px 0px rgba(0, 0, 0, 0.30)",
            background: "rgba(255, 255, 255, 0.70)",
            backdropFilter: "blur(25px)",
            overflow: "hidden",
          },
        }}
      >
        {activeStep !== 1 && activeStep !== 7 && activeStep !== 8 && (
          <div
            className="back-btn-container flex gap-10"
            onClick={handleStepChange(-1)}
          >
            <img src="../backButton.svg" alt="back" className="back-btn" /> Back
          </div>
        )}
        {[
          OnboardingStep1,
          OnboardingStep2,
          OnboardingStep3,
          OnboardingStep4,
          OnboardingStep5,
          OnboardingStep6,
          OnboardingStep7,
          OnboardingStep8,
        ].map((StepComponent, index) =>
          activeStep === index + 1 ? renderStep(StepComponent, index) : null
        )}
      </Modal>
    </div>
  );
};

export default OnBoarding;